import { fetchAuthSession } from "@aws-amplify/auth";

/**
 * Get ID token for user-specific endpoints (Cognito user management)
 * Use this for: /cognito/user-preferences, /cognito/users, etc.
 */
export async function getIdToken(forceRefresh = false): Promise<string | null> {
  try {
    const session = await fetchAuthSession({ forceRefresh });

    if (!session.tokens?.idToken) {
      console.warn("[getIdToken] No ID token in session");
      return null;
    }

    const token = session.tokens.idToken.toString();
    console.log("[getIdToken] Token retrieved successfully");
    return token;
  } catch (error) {
    console.error("[getIdToken] Error getting token:", error);
    return null;
  }
}

/**
 * Get access token for API resource endpoints
 * Use this for: /api/*, /vis/*, /weather/*, etc.
 */
export async function getAccessToken(forceRefresh = false): Promise<string | null> {
  try {
    const session = await fetchAuthSession({ forceRefresh });

    if (!session.tokens?.accessToken) {
      console.warn("[getAccessToken] No access token in session");
      return null;
    }

    const token = session.tokens.accessToken.toString();
    console.log("[getAccessToken] Token retrieved successfully");
    return token;
  } catch (error) {
    console.error("[getAccessToken] Error getting token:", error);
    return null;
  }
}
